import React, { memo } from 'react';

import classNames from 'classnames';

import { UiButton } from '@shared/ui';

import { useWeatherBlock } from './useWeatherBlock';
import cls from './WeatherBlock.module.css';
import { Icon } from '../../../../components/newUI/Icon/Icon';

interface WeatherBlockProps {
    classes?: string;
    can_show_financial_info?: boolean;
    is_customer?: boolean;
}

export const EmptyWeatherBlock = memo(
    ({ classes, can_show_financial_info, is_customer }: WeatherBlockProps) => {
        const { onAddWeather } = useWeatherBlock();

        return (
            <div className={classNames(cls.WeatherBlock, cls.emptyWrapper, [classes])}>
                <div
                    className={classNames(cls.emptyWeather, {
                        [cls.emptyWeatherNonFinance]: !can_show_financial_info || is_customer,
                    })}
                />
                <div className={cls.emptyContent}>
                    <h3>{i18next.t('EmptyWeatherBlock.return.title')}</h3>
                    <div className={cls.message}>
                        {is_customer ? (
                            <div className={cls.subtitle}>
                                {i18next.t('EmptyWeatherBlock.return.subtitle.part1')}
                                <br />
                                {i18next.t('EmptyWeatherBlock.return.subtitle.part2')}
                            </div>
                        ) : (
                            <div
                                className={classNames(cls.subtitle, {
                                    [cls.notShow]: is_customer || !can_show_financial_info,
                                })}
                            >
                                {i18next.t('EmptyWeatherBlock.return.subtitle.notAccess.part1')}
                                <br />
                                {i18next.t('EmptyWeatherBlock.return.subtitle.notAccess.part2')}
                            </div>
                        )}
                        {!is_customer && can_show_financial_info && (
                            <div className={cls.buttonWrapper}>
                                <UiButton
                                    onClick={onAddWeather}
                                    startIcon={<Icon iconName="whitePlus" />}
                                    btnText={i18next.t('EmptyWeatherBlock.return.button')}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
);
